// @flow
import './App.css';
import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import auth from '../../auth';
import clients from '../../clients';
import sessions from '../../sessions';
import settings from '../../settings';

import Header from './Header';
import Footer from './Footer';
import NotFound from './NotFound';

export class App extends Component {
  async componentDidMount() {
    if (!this.props.isAuthenticated) {
      await this.props.loadSession(this.props.history);
    }
  }

  render() {
    if (this.props.isAuthenticating) {
      // Show a loading spinner
      return null;
    }

    if (!this.props.isAuthenticated) {
      // Don't show App if not authenticated
      return null;
    }

    return (
      <div className="container-fluid">
        <div className="row">
          <Header />
          <Switch>
            <Route
              path="/clients"
              component={clients.components.ClientRoutes}
            />
            <Route
              path="/sessions"
              component={sessions.components.SessionRoutes}
            />
            <Route
              path="/settings"
              component={settings.components.SettingsRoutes}
            />
            <Route component={NotFound} />
          </Switch>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  isAuthenticated: auth.selectors.getIsAuthenticated,
  isAuthenticating: auth.selectors.getIsAuthenticating
});

export default connect(mapStateToProps, auth.actions)(withRouter(App));



// WEBPACK FOOTER //
// ./src/modules/core/components/App.js